import Decimal from 'decimal.js';
import { ValueTransformer } from 'typeorm';

export class ColumnNumericTransformer {
  to(data: number): number {
    return data;
  }
  from(data: string): number {
    return parseFloat(data);
  }
}

export class ColumnDecimalTransformer implements ValueTransformer {
  // called when saving value -> DB
  to(value: Decimal | number | string | null | undefined): string | null | undefined {
    if (value === null || value === undefined) return value;
    return new Decimal(value).toFixed(2, Decimal.ROUND_HALF_EVEN); // always keep 2 decimals
  }

  // called when reading value <- DB
  from(value: string | null | undefined): Decimal | null | undefined {
    if (value === null || value === undefined) return value;
    return new Decimal(value);
  }
}

export const DecimalTransformer = (decimalPlaces = 7) => {
  // Bankers' rounding (round-half-even)
  const roundingMode = Decimal.ROUND_HALF_EVEN;

  return {
    to: (value: number | string | null | undefined): number | null | undefined => {
      if (value === null || value === undefined) return value;

      return new Decimal(value).toDecimalPlaces(decimalPlaces, roundingMode).toNumber();
    },
    from: (value: number | string | null | undefined): number | null | undefined => {
      if (value === null || value === undefined) return value;
      return new Decimal(value).toDecimalPlaces(decimalPlaces, roundingMode).toNumber();
    },
  };
};
